import { render, staticRenderFns } from "./pulse-statistics.vue?vue&type=template&id=7ed4bce0&scoped=true"
import script from "./pulse-statistics.vue?vue&type=script&lang=js"
export * from "./pulse-statistics.vue?vue&type=script&lang=js"
import style0 from "./pulse-statistics.vue?vue&type=style&index=0&id=7ed4bce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed4bce0",
  null
  
)

export default component.exports